<script>
export default {
    name: "CancelUnpostedBillForm",
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:breadcrum></template>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                <h5 class="font-bold text-sm">Cancel Unposted Bills</h5>
              </template>
              <template v-slot:card-body>
                  <div class="w-full flex md:flex-row sm:flex-col">
                      <div class="flex-1 p-1">
                          <label for="grid-search" class="label-control">Filter</label>
                          <input type="text" id="grid-search" class="input-control input-sm text-xs" placeholder="Search">
                      </div>
                      <div class="flex-1 p-1">
                          <label for="grid-date-from" class="label-control">Date From</label>
                          <input type="date" id="grid-date-from" class="input-control input-sm text-xs">
                      </div>
                      <div class="flex-1 p-1">
                          <label for="grid-date-to" class="label-control">Date To</label>
                          <input type="date" id="grid-date-to" class="input-control input-sm text-xs">
                      </div>
                      <div class="flex-1 p-1">
                          <label for="grid-item-search" class="label-control">Item</label>
                          <v-select id="grid-item-search" class="bg-white text-xs"></v-select>
                      </div>
                      <div class="flex-1 p-1">
                          <label for="grid-user-search" class="label-control">User</label>
                          <v-select id="grid-user-search" class="bg-white text-xs"></v-select>
                      </div>
                      <div class="flex-1 p-1 text-center pt-2">
                          <button class="btn-sm btn-info text-sm mt-4"><i class="fa fa-filter"></i> Filter</button>
                      </div>
                  </div>
                <table class="table table-hover">
                    <thead class="bg-blue-500 text-sm text-white whitespace-no-wrap">
                        <tr>
                            <th class="p-tiny">ID</th>
                            <th class="p-tiny">Patient</th>
                            <th class="p-tiny">IP NO</th>
                            <th class="p-tiny">OP NO</th>
                            <th class="p-tiny">Amt</th>
                            <th class="p-tiny">Select</th>
                        </tr>
                    </thead>
                    <tbody class="text-xs">
                        <tr>
                            <td class="p-tiny"></td>
                            <td class="p-tiny"></td>
                            <td class="p-tiny"></td>
                            <td class="p-tiny"></td>
                            <td class="p-tiny"></td>
                            <td class="p-tiny"></td>
                        </tr>
                    </tbody>
                </table>
                <div class="flex flex-wrap">
                    <div class="md:w-1/2 sm:w-full p-1">
                        <label for="grid-cancel-memo" class="label-control">Cancel Memo</label>
                        <textarea id="grid-cancel-memo" cols="30" rows="2" class="input-sm input-control text-xs"></textarea>
                    </div>
                    <div class="md:w-1/2 sm:w-full p-1 flex justify-end">
                        <h5 class="font-bold mt-5">Total Amount: <span class="text-blue-400">0.00</span></h5>
                    </div>
                </div>
                <div class="flex justify-end p-1 mt-1 bg-gray-400 border-2">
                    <button class="btn-sm btn-primary text-sm"><i class="fa fa-save"></i> Initiate Bulk Cancel</button>
                </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>